import { create } from 'zustand';
import { persist } from 'zustand/middleware';

export interface MenuAccessData {
  count: number;
  lastAccess: number;
}

interface MyPageState {
  menuAccess: Record<string, MenuAccessData>;
  trackAccess: (menuId: string) => void;
  reset: () => void;
}

export const useMyPageStore = create<MyPageState>()(
  persist(
    (set) => ({
      menuAccess: {},
      trackAccess: (menuId) =>
        set((state) => ({
          menuAccess: {
            ...state.menuAccess,
            [menuId]: {
              count: (state.menuAccess[menuId]?.count ?? 0) + 1,
              lastAccess: Date.now(),
            },
          },
        })),
      reset: () => set({ menuAccess: {} }),
    }),
    {
      name: 'wello:my:quickIcons',
      version: 1,
      skipHydration: true,
    },
  ),
);

export function switchMyPageUser(userId: string | null) {
  try {
    if (!userId) {
      useMyPageStore.getState().reset();

      return;
    }
    useMyPageStore.persist.setOptions({
      name: `wello:my:quickIcons:${userId}`,
    });
    void useMyPageStore.persist.rehydrate();
  } catch {
    // Safari 프라이빗 모드 등 localStorage 접근 불가 시 무시
  }
}
